
export const COLUMNS = [
    {
        Header: ' ',
        accessor:'id',
        disableSortBy: true,
        width: '50',
        Cell: ({value}) => (
            <a href={`/companies/${value}`} style={{"width":"100px", "height":"50px"}}><i className="fa-solid fa-eye"></i></a>)
    },
    {
        Header: 'Logo',
        accessor:'logo',
        width: '75',
        Cell: ({value}) => (
            <img
              src={value}
              height='30px'
              alt='Player'/>)
    },
    {
        Header: 'Name',
        accessor:'name',
    },
    // {
    //     Header: 'Contact Person Role',
    //     accessor:'contactPersonRole',
    // },
    {
        Header: 'University',
        accessor:'university',
    },
    {
        Header: 'Website',
        accessor:'website',
        Cell: ({value}) => (
            <a href={value} style={{"width":"100px", "height":"50px"}}>{value}</a>)
    },
    {
        Header: 'Location',
        accessor:'geoLocationCoordinates',
    },
    // {
    //     Header: 'Countries',
    //     accessor:'countries',
    // },
    // {
    //     Header: 'NACE',
    //     accessor:'mainNACE',
    // },
    // {
    //     Header: 'Company Activity',
    //     accessor:'companyActivity',
    // },
    // {
    //     Header: 'Business Model',
    //     accessor:'bussinessModel',
    // },
    // {
    //     Header: 'Employee Count',
    //     accessor:'employeeCount',
    // },
    {
        Header: 'Year Founded',
        accessor:'yearFounded',
    },
    // {
    //     Header: 'Initial Country',
    //     accessor:'initialCountry',
    // },
    {
        Header: 'Turnover',
        accessor:'turnoverN',
    },
    // {
    //     Header: 'Turnover N1',
    //     accessor:'turnoverN1',
    // },
    // {
    //     Header: 'Turnover N2',
    //     accessor:'turnoverN2',
    // },
    // {
    //     Header: 'Turnover N3',
    //     accessor:'turnoverN3',
    // },
    // {
    //     Header: 'Turnover N4',
    //     accessor:'turnoverN4',
    // },
    // {
    //     Header: 'Revenue',
    //     accessor:'preRevenue',
    // },
    // {
    //     Header: 'Entreprenourship',
    //     accessor:'entreprenourship',
    // },
    // {
    //     Header: 'Innovation',
    //     accessor:'innovationEducation',
    // },
    // {
    //     Header: 'Mentorship',
    //     accessor:'mentorship',
    // },
    // {
    //     Header: 'Incubation Services',
    //     accessor:'incubationServices',
    // },
    // {
    //     Header: 'Acceleration Services',
    //     accessor:'accelerationServices',
    // },
    // {
    //     Header: 'Funding Provideds',
    //     accessor:'fundingProvided',
    // },
    // {
    //     Header: 'Collaborative RDP',
    //     accessor:'collaborativeRDP',
    // },
    // {
    //     Header: 'Patent',
    //     accessor:'patent',
    // },
    // {
    //     Header: 'Internship',
    //     accessor:'internship',
    // },
    // {
    //     Header: 'Spinoff',
    //     accessor:'spinoff',
    // },
    // {
    //     Header: 'Founders Are Alumni',
    //     accessor:'foundersAreAlumni',
    // },
    // {
    //     Header: 'Percentage Employee Alumni',
    //     accessor:'percentageEmployeeAlumni',
    // },
    // {
    //     Header: 'Percentage Employee Tertiary Ed',
    //     accessor:'percentageEmployeeTertiaryEd',
    // },
    // {
    //     Header: 'Percentage Employee PHD',
    //     accessor:'percentageEmployeePHD',
    // },
    // {
    //     Header: 'Num Scientific Copublications',
    //     accessor:'numScientificCopublications',
    // },
    // {
    //     Header: 'Percentage RD Expediture',
    //     accessor:'percentageRDExpediture',
    // },
    // {
    //     Header: 'Has Innovations',
    //     accessor:'hasInnovations',
    // },
    // {
    //     Header: 'Has Intelectual Assets',
    //     accessor:'hasIntelectualAssets',
    // },
    // {
    //     Header: 'Aligned UNSDG',
    //     accessor:'alignedUNSDG',
    // },
    // {
    //     Header: 'Generating Periodical Report',
    //     accessor:'generatingPeriodicalReport',
    // },
    // {
    //     Header: 'Has Raised Investment Round',
    //     accessor:'hasRaisedInvestmentRound',
    // },
    // {
    //     Header: 'Has Raised Nondillutive Founding',
    //     accessor:'hasRaisedNonDillutiveFounding',
    // },
    // {
    //     Header: 'Entrepreneurial Booster Scheme',
    //     accessor:'entrepreneurialBoosterScheme',
    // },
    // {
    //     Header: 'CEO is Woman',
    //     accessor:'isCEOWoman',
    // },
    
]